//Modified from:
// https://stackoverflow.com/questions/34097560/react-js-replace-img-src-onerror
import React, { Component } from "react";

interface IProps {
	src: string;
	fallbackSrc?: string;

	className?: string;
	alt?: string;
}

export default class Image extends Component<IProps> {
	state = {
		src: "",
		errored: false
	};

	constructor(props: IProps) {
		super(props);

		this.state = {
			src: props.src,
			errored: false,
		};
	}

	onError = () => {
		if (!this.state.errored) {
			this.setState({
				src: this.props.fallbackSrc,
				errored: true,
			});
		}
	}

	render() {
		const { src } = this.state;
		const {
			src: _1,
			fallbackSrc: _2,
			...props
		} = this.props;

		return (
			<img
				src={src}
				onError={this.onError}
				alt={this.props.alt}
				{...props}
			/>
		);
	}
}